import { useLazyGetUsersQuery } from "@/shared/services";
import type { IUser } from "@/types";
import { STORYDOC_AVATAR, STORYDOC_PREFIX, UNKNOWN_AVATAR } from "../constants";

export const useResolveUsers = () => {
  const { query: getUsers } = useLazyGetUsersQuery();

  const resolveUsers = async ({ userIds }: { userIds: string[] }) => {
    const users = await getUsers();
    return userIds.map((id: string) => {
      const user = users.find((user: IUser) => user._id === id);
      let avatar = user?.profile?.picture || "";
      let name = user?.firstName || "Anonymous";
      if (!user) avatar = UNKNOWN_AVATAR;
      if (id.startsWith(STORYDOC_PREFIX)) {
        avatar = STORYDOC_AVATAR;
        name = "Storydoc";
      }

      return {
        name,
        avatar,
      };
    });
  };

  return resolveUsers;
};
